import type React from 'react';
import { useContext, useEffect, useRef } from 'react';
import TagManager from 'react-gtm-module';

import constants from './../../constants';
import { CookiebotContext } from '../../state/CookiebotContextProvider';
import { isFeatureEnabled } from '../../utils/feature';

const GoogleTagManager: React.FC = () => {
	const consent = useContext(CookiebotContext);
	// Initializing injects the container script — guard it to once per mount so
	// context re-renders don't re-inject it.
	const initializedRef = useRef(false);

	useEffect(() => {
		if (initializedRef.current || !isFeatureEnabled('googleAnalytics') || !consent.statistics) return;
		// Only production configures a container id; react-gtm-module would still
		// inject `gtm.js?id=` for an empty one.
		if (!constants.gtmId) return;
		initializedRef.current = true;
		TagManager.initialize({ gtmId: constants.gtmId });
	}, [consent.statistics]);

	return null;
};

export default GoogleTagManager;
